export const FETCH_OVERVIEW_REQUEST = 'FETCH_OVERVIEW_REQUEST';
export const FETCH_OVERVIEW_SUCCESS = 'FETCH_OVERVIEW_SUCCESS';
export const FETCH_OVERVIEW_FAILURE = 'FETCH_OVERVIEW_FAILURE';

export const FETCH_SALES_CHART_REQUEST = 'FETCH_SALES_CHART_REQUEST';
export const FETCH_SALES_CHART_SUCCESS = 'FETCH_SALES_CHART_SUCCESS';
export const FETCH_SALES_CHART_FAILURE = 'FETCH_SALES_CHART_FAILURE';

export const FETCH_ORDERS_CHART_REQUEST = 'FETCH_ORDERS_CHART_REQUEST';
export const FETCH_ORDERS_CHART_SUCCESS = 'FETCH_ORDERS_CHART_SUCCESS';
export const FETCH_ORDERS_CHART_FAILURE = 'FETCH_ORDERS_CHART_FAILURE';

export const FETCH_REVENUE_BY_STORE_REQUEST = 'FETCH_REVENUE_BY_STORE_REQUEST';
export const FETCH_REVENUE_BY_STORE_SUCCESS = 'FETCH_REVENUE_BY_STORE_SUCCESS';
export const FETCH_REVENUE_BY_STORE_FAILURE = 'FETCH_REVENUE_BY_STORE_FAILURE';
